/* eslint-disable no-param-reassign */
import 'amfe-flexible/index';
import './assets/styles/entry.less';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import App from './App';
import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {Provider} from 'react-redux';
import reducer from './reducer/index';
const store = createStore(reducer, applyMiddleware(thunk));

ReactDOM.render(
  <HashRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </HashRouter>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js